import { BiteLogChaseEvent } from './bite_log_chase_event.js';

export function name(event: BiteLogChaseEvent): string {
  switch (event) {
    case BiteLogChaseEvent.None:
      return 'ok';
    case BiteLogChaseEvent.TerminalConnected:
      return 'terminal-connected';
    case BiteLogChaseEvent.TerminalDisconnected:
      return 'terminal-disconnected';
    case BiteLogChaseEvent.SaleTransaction:
      return 'sale-transaction';
    case BiteLogChaseEvent.SaleTransactionError:
      return 'sale-transaction-error';
    case BiteLogChaseEvent.DeviceSetup:
      return 'device-setup';
    case BiteLogChaseEvent.CloseTransaction:
      return 'close-transaction';
    case BiteLogChaseEvent.CloseTransactionError:
      return 'close-transaction-error';
    case BiteLogChaseEvent.RefundTransactionRequested:
      return 'refund-transaction-requested';
    case BiteLogChaseEvent.RefundTransaction:
      return 'refund-transaction';
    case BiteLogChaseEvent.RefundTransactionError:
      return 'refund-transaction-error';
    case BiteLogChaseEvent.Logs:
      return 'logs';
  }
}
